/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { ClaimType } from '@constants';
import { SliceName } from '../constants';

export const claimSlice = createSlice({
  name: SliceName.Claim,
  initialState: {
    type: ClaimType.Init,
    files: [],
    // files1: [],
    delayPackageId: '',
    selectedItems: [],
    orderName: '',
    packageList: [],
    unfulfilledItemList: [],
    policyId: '',
    currentPolicy: {
      liabilitiesArr: [],
    },
    // new
    fulfilledItems: [],
    unFulfilledItems: [],
    paymentMethod: {}, // store payment method
    paymentInfo: {}, // store payment card
    returnMethod: {}, // store return method
    reviewData: {},
    supportedPaymentMethod: [],
    orderNumber: '',
    selectedTotalMoney: '',
    dhgateFulfillments: [],
    dhgateItems: [],
    selectedDhgateItems: {},
    gptDimensionInfo: {},
  },
  reducers: {
    setPackageList(state, { payload }) {
      if (!payload) {
        return;
      }
      const {
        orderName = '',
        fulfilledItems = [],
        unFulfilledItems = [], returnCoverageDay,
      } = payload;
      state.fulfilledItems = fulfilledItems.map((v) => ({
        ...v,
        items: v.items.map((item) => ({
          ...item, fulfillmentId: v.fulfillmentId, trackingNumber: v.trackingNumber,
        })),
      }));
      state.orderName = orderName;
      state.returnCoverageDay = returnCoverageDay || 7;
      const unFulfilledList = [];
      unFulfilledItems.forEach((item) => {
        item.items.forEach((v) => unFulfilledList.push(v));
      });
      state.unFulfilledItems = unFulfilledList;
    },
    setDhgatePackage(state, { payload }) {
      if (!payload) return;
      const { fulfillments = [], items = [] } = payload;
      state.dhgateFulfillments = fulfillments;
      state.dhgateItems = items;
    },
    setClaimInfo(state, { payload }) {
      state.type = payload.type;
      state.liabilityId = payload.id;
      state.policyId = payload.policyId;
      state.supportedPaymentMethod = payload.supportedPaymentMethod || [];
      state.orderNumber = payload.orderNumber;
      state.merchantId = payload.merchantId;
      state.currentPolicy = {
        ...payload,
        liabilitiesArr: payload?.liabilities?.reduce((prev, cur) => {
          prev.push(cur.code);
          return prev;
        }, []) || [],
      };
    },
    setUploadChosen(state, { payload }) {
      state.files = payload.files;
      state.comments = payload.comments;
    },
    setDelayPackageId(state, { payload }) {
      state.delayPackageId = payload;
    },
    addSelectedItems(state, { payload }) {
      const { selectedItems } = state;
      const index = selectedItems.findIndex((item) => item === payload);
      if (index > -1) {
        return;
      }
      selectedItems.push(payload);
    },
    deleteSelectedItems(state, { payload }) {
      const { selectedItems } = state;
      const index = selectedItems.findIndex((item) => item === payload);
      if (index === -1) {
        return;
      }
      selectedItems.splice(index, 1);
    },
    clearSelectedItems(state) {
      state.selectedItems = [];
      state.selectedData = {};
    },
    // RA 添加原因
    addPackageReason(state, { payload }) {
      const { willChecked: { packageIndex, lineIndex }, reason } = payload;
      state.fulfilledItems[packageIndex].items[lineIndex].reason = reason.type;
      state.fulfilledItems[packageIndex].items[lineIndex].comment = reason.comments?.trim();
      state.fulfilledItems[packageIndex].items[lineIndex].attachments = reason.files;
    },
    /**
* @param {Object} selectedData review入参，保存后让提交接口取用
* @param {Array} selectedPackageList review页面渲染用
*/
    setSelectedData(state, { payload }) {
      state.selectedData = payload.body;
      state.selectedPackageList = payload.selectedPackageList;
      state.totalMoneyValue = payload.totalMoneyValue;
    },

    setPaymentMethod(state, { payload }) {
      if (!payload) {
        return;
      }
      state.paymentMethod = payload;
    },
    setPaymentInfo(state, { payload }) {
      if (!payload) {
        return;
      }
      state.paymentInfo = payload;
    },
    setReturnMethod(state, { payload }) {
      if (!payload) {
        return;
      }
      state.returnMethod = payload;
    },
    setReviewInfo(state, { payload }) {
      if (!payload) {
        return;
      }
      state.reviewData = payload;
    },
    setSelectedTotalMoney(state, { payload }) {
      if (!payload) {
        return;
      }
      state.selectedTotalMoney = payload;
    },
    updateSelectedDhgateItems(state, { payload }) {
      if (!payload) {
        return;
      }
      const {
        info, currentItem, selectType,
      } = payload;
      const { selectedDhgateItems, delayPackageId } = state;
      // const index = selectedDhgateItems.findIndex((item) => item.lineItemId === currentItem.lineItemId);
      if (selectType === 'add') {
        const selectedInfo = {
          lineItemId: currentItem.lineItemId,
          fulfillmentId: delayPackageId,
          assetId: currentItem.assetId,
          ...info,
        };
        // if (index > -1) {
        //   selectedDhgateItems[index] = selectedInfo;
        // } else {
        //   selectedDhgateItems.push(selectedInfo);
        // }
        selectedDhgateItems[currentItem.lineItemId] = selectedInfo;
      } else if (selectType === 'delete') {
        delete selectedDhgateItems[currentItem.lineItemId];
      }
    },
    clearSelectedDhgateItems(state) {
      state.selectedDhgateItems = {};
    },
    setGPTDimensionInfo(state, { payload }) {
      if (!payload) {
        return;
      }
      state.gptDimensionInfo = payload;
    },
  },
});

export const {
  setPackageList,
  setClaimInfo,
  setUploadChosen,
  setDelayPackageId,
  addSelectedItems,
  deleteSelectedItems,
  clearSelectedItems,
  addPackageReason,
  setSelectedData,
  setPaymentMethod,
  setPaymentInfo,
  setReturnMethod,
  setReviewInfo,
  setSelectedTotalMoney,
  setDhgatePackage,
  updateSelectedDhgateItems,
  clearSelectedDhgateItems,
  setGPTDimensionInfo,
} = claimSlice.actions;

export default claimSlice.reducer;
